import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel" ]

  connect() {
    if (new URLSearchParams(window.location.search).get("modal") === "open") {
      this.open()
    }

    this.modalCloseHandler = () => this.close()
    this.element.addEventListener("modal:close", this.modalCloseHandler)
    
    this.frame = this.element.querySelector("turbo-frame")
    if (this.frame) {
      this.observer = new MutationObserver(() => {
        if (this.frame.innerHTML.trim() === "") {
          this.close()
        }
      })
      this.observer.observe(this.frame, { childList: true })
    }
  }

  disconnect() {
    this.element.removeEventListener("modal:close", this.modalCloseHandler)
    this.observer?.disconnect()
  }

  open() {
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    document.body.classList.remove("overflow-hidden")

    const frame = this.element.querySelector("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      if (frame.innerHTML.trim() !== "") {
        setTimeout(() => {
          frame.innerHTML = ""
        }, 0)
      }
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}
